/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { CreatePatientAvatarBody, UpdateAvatarErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const createPatientAvatar = (
  patientId: string,
  createPatientAvatarBody: CreatePatientAvatarBody,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`avatar`, createPatientAvatarBody.avatar);

  return api<void>({
    url: `/api/patient/${patientId}/avatar`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getCreatePatientAvatarMutationOptions = <
  TError = UpdateAvatarErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPatientAvatar>>,
    TError,
    { patientId: string; data: CreatePatientAvatarBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPatientAvatar>>,
  TError,
  { patientId: string; data: CreatePatientAvatarBody },
  TContext
> => {
  const mutationKey = ['createPatientAvatar'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPatientAvatar>>,
    { patientId: string; data: CreatePatientAvatarBody }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return createPatientAvatar(patientId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePatientAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPatientAvatar>>
>;
export type CreatePatientAvatarMutationBody = CreatePatientAvatarBody;
export type CreatePatientAvatarMutationError = UpdateAvatarErrorResponse;

export const useCreatePatientAvatar = <TError = UpdateAvatarErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPatientAvatar>>,
      TError,
      { patientId: string; data: CreatePatientAvatarBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPatientAvatar>>,
  TError,
  { patientId: string; data: CreatePatientAvatarBody },
  TContext
> => {
  const mutationOptions = getCreatePatientAvatarMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
